'use strict';//Indicating browser should run only in java script mode

//var EMRRxInpatientViewModule = angular.module('EMR.RxInpatientViewModule', []);
;(function (){
var ConsentToTakeMedsRoutes = [

    
    {
        name: "Consent_To_Take_Medications_Tabs_Main_View",
        //"url": "RxNewPrescriptionCurrentMeds/:patientChartInfo",
        templateUrl: "<div emr-consent-to-take-medications-tabs-main-view></div>",
        directivescontrollersFiles: "directiveFiles",
        RoutingNumber: 3135,
        files: [
            "AngularScripts/ConsentToTakeMeds/Services/ConsentToTakeMedsService.js",
            "AngularScripts/ConsentToTakeMeds/Directives/ConsentToTakeMedicationsTabsMainViewDirective.js"
        ]
    },

    {
        state: true,
        name: "ConsentToTakeMedicationWindowInfo",
        url: "ConsentToTakeMedicationWindowInfo/:patientChartInfo",
        templateUrl: "<div emr-consent-to-take-medications-tabs-main-view></div>",
        //directivescontrollersFiles: "4206,4221,3070",
        RoutingNumber: 3135,
        files: [
            "AngularScripts/ConsentToTakeMeds/Services/ConsentToTakeMedsService.js",
            "AngularScripts/ConsentToTakeMeds/Directives/ConsentToTakeMedicationsTabsMainViewDirective.js"
        ]
    }, 

];


angular.module('EMR.ConsentToTakeMedsModule',[])
    .config(["$stateProvider", "EmrRouteProvider",
        function ($stateProvider, EmrRouteProvider) {
            EmrRouteProvider.registerStates(ConsentToTakeMedsRoutes, $stateProvider);
        }]);
    })();